module.exports = __webpack_public_path__ + "img/step1-1-tu.73bdf115.png";